<template>
  <table v-if="quote" class="table mb-5">
    <thead>
      <tr>
        <th class="text-left" scope="col" v-dynamic-content:pv_expense_summary_title></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <!-- show when contractPrice exists and contractPriceExclVAT not given -->
      <tr
        v-if="quote.detailOverview.contractPrice && !quote.detailOverview.contractPriceExclVAT"
      >
        <td class="text-left" v-dynamic-content:pv_overview_summary_investment></td>
        <td class="text-right">{{ quote.detailOverview.contractPrice | formatCurrency }}</td>
      </tr>
      <tr v-if="quote.detailOverview.contractPriceExclVAT">
        <td class="text-left" v-dynamic-content:pv_overview_summary_investment></td>
        <td class="text-right">
          {{ quote.detailOverview.contractPriceExclVAT | formatCurrency }}
        </td>
      </tr>
      <tr v-if="quote.detailOverview.pvSubsidy || quote.detailOverview.batterySubsidy">
        <td
          class="text-left"
          v-dynamic-content:pv_overview_summary_investment_including_subsidies
        ></td>
        <td class="text-right">{{ calculateInvestmentIncludingSubsidies | formatCurrency }}</td>
      </tr>
      <tr v-if="quote.detailOverview.inverterReplacementPrice">
        <td class="text-left" v-dynamic-content:pv_overview_summary_inverterprice></td>
        <td class="text-right">
          {{ quote.detailOverview.inverterReplacementPrice | formatCurrency }}
        </td>
      </tr>
      <tr v-if="quote.detailOverview.inverterAndBatteryReplacementPrice && country === 'be'">
        <td
          class="text-left"
          v-dynamic-content:pv_overview_summary_inverter_and_battery_replacement_price
        ></td>
        <td class="text-right">
          {{ quote.detailOverview.inverterAndBatteryReplacementPrice | formatCurrency }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DetailExpenseInformation',
  props: ['quote'],
  computed: {
    calculateInvestmentIncludingSubsidies() {
      const { batterySubsidy, pvSubsidy, contractPrice, contractPriceExclVAT } =
        this.quote.detailOverview
      const chosenInvestment =
        contractPrice && !contractPriceExclVAT ? contractPrice : contractPriceExclVAT
      return chosenInvestment - (batterySubsidy + pvSubsidy)
    },
    country() {
      return this.$store.getters.country
    },
  },
}
</script>
